import React, { useState } from "react";
import {
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import requiredPassSchema from "../../validations/UserValidation";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../../api/axios";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { toast } from "react-toastify";

export default function ResetPassword() {
  const [showPass, setShowPass] = useState(false);
  const [showPassConfirmation, setShowPassConfirmation] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  

  const initialValues = {
    email: "",
    password: "",
  };

  const handlePassVisibility = () => {
    
    setShowPass(!showPass);
  };

  const handlePassConfirmationVisibility = () => {
    
    setShowPassConfirmation(!showPassConfirmation);
  };

  const onSubmit = async (data, props) => {
    try {
      const response = await api.put("/api/v1/password", {
        user: {
          reset_password_token: token,
          password: data.password,
          password_confirmation: data.confirmationPassword,
        },
      });

      toast.success("Contraseña actualizada");
      navigate("/", { replace: true });
      
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
      } else {
        let errors = err.response.data.error;

        if (Array.isArray(errors)) {
          errors = errors.join(", ");
        }
        toast.error(errors);
      }
    }
  };

  return (
    <Container maxWidth="sm">
      <h1 align="center">Restablecer contraseña</h1>
      <Grid
        container
        spacing={2}
        direction="column"
        justifyContent="center"
        style={{ minHeigt: "100vh" }}
      >
        <Paper elevation={2} sx={{ padding: 5 }}>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={requiredPassSchema}
          >
            {(props) => (
              <Form>
                <Grid container direction="column" spacing={2}>
                  <Grid item>
                    <Field
                      as={TextField}
                      name="password"
                      htmlFor="password"
                      type={showPass ? "text" : "password"}
                      fullWidth
                      label="Ingrese nueva contraseña"
                      placeholder="Contraseña"
                      variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handlePassVisibility}
                              arial-label="toggle password"
                              edge="end"
                            >
                              {showPass ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      error={
                        !!props?.errors?.password && props?.touched?.password
                      }
                      helperText={<ErrorMessage name="password" />}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Field
                      as={TextField}
                      name="confirmationPassword"
                      type={showPassConfirmation ? "text" : "password"}
                      fullWidth
                      label="Confirma la contraseña"
                      placeholder="Contraseña"
                      variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handlePassConfirmationVisibility}
                              arial-label="toggle password"
                              edge="end"
                            >
                              {showPassConfirmation ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      error={
                        !!props?.errors?.confirmationPassword &&
                        props?.touched?.confirmationPassword
                      }
                      helperText={<ErrorMessage name="confirmationPassword" />}
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      fullWidth
                      type="submit"
                      disabled={props.isSubmitting}
                    >
                      Restablecer
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Paper>
      </Grid>
    </Container>
  );
}
